import React from "react";

const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <div
    href="a"
    className="position-unset"
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
  >
    {children}
  </div>
));

export default CustomToggle;
